<div *ifWideLayout class="flex items-center gap-0.5">
  <span class="text-md text-primary font-medium">{{ 'examdojo.sort.sort_by' | transloco }}:</span>
  <dojo-button
    [fill]="'clear'"
    [matMenuTriggerFor]="sortMenu"
    #matMenuTriggerForSortMenu="matMenuTrigger"
    [size]="'s'"
    class="sort-button-trigger"
  >
    <span class="text-md text-primary font-medium">{{ state.currentSortText }}</span>
    <dojo-icon [icon]="matMenuTriggerForSortMenu.menuOpen ? 'chevron-up' : 'chevron-down'" class="ml-1" />
  </dojo-button>

  <mat-menu #sortMenu="matMenu" class="sort-menu">
    @for (option of state.sortOptions; track option.value) {
      <button mat-menu-item [class.active]="sortCtrl.value === option.value" (click)="selectSortOption(option.value)">
        <span>{{ option.label }}</span>
      </button>
    }
  </mat-menu>
</div>

<dojo-button
  *ifSmallLayout
  [matMenuTriggerFor]="sortMenuMobile"
  #sortMenuTriggerMobile="matMenuTrigger"
  [fill]="'outline'"
  [size]="'m'"
>
  <dojo-icon [icon]="'arrow-up-arrow-down'" class="mr-2" />
  <span class="font-medium">{{ 'examdojo.sort.sort' | transloco }}</span>
  <dojo-icon [icon]="sortMenuTriggerMobile.menuOpen ? 'chevron-up' : 'chevron-down'" class="ml-2" />
</dojo-button>

<mat-menu #sortMenuMobile="matMenu" class="sort-menu">
  @for (option of state.sortOptions; track option.value) {
    <button mat-menu-item [class.active]="sortCtrl.value === option.value" (click)="selectSortOption(option.value)">
      <span>{{ option.label }}</span>
    </button>
  }
</mat-menu>
